import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { ArrowRight, Settings } from 'lucide-react';

interface JumpNodeData {
  title?: string;
  targetNode?: string;
  targetNodeName?: string;
  jumpLimit?: number;
  color?: string;
  tags?: string[];
}

export const JumpNode = memo(({ data, isConnectable }: NodeProps<JumpNodeData>) => {
  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white border-2 border-red-200 hover:border-red-400 transition-colors duration-300">
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        className="w-3 h-3 bg-red-500"
      />
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <ArrowRight className="h-4 w-4 mr-2" style={{ color: data.color || '#ef4444' }} />
          <div className="text-sm font-medium text-gray-900">
            {data.title || 'Saltar'}
          </div>
        </div>
        <Settings className="h-4 w-4 text-gray-400" />
      </div>
      <div className="mt-2 text-sm text-gray-600">
        <div>
          {data.targetNode ? `Saltar a: ${data.targetNodeName || data.targetNode}` : 'Sin destino configurado'}
        </div>
        {data.jumpLimit && (
          <div className="mt-1 text-xs text-gray-500">
            Límite: {data.jumpLimit} saltos
          </div>
        )}
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        id="default"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-red-500"
      />
    </div>
  );
});

JumpNode.displayName = 'JumpNode';